import { render, staticRenderFns } from "./ResolvedReports.vue?vue&type=template&id=76f10726"
import script from "./ResolvedReports.vue?vue&type=script&lang=js"
export * from "./ResolvedReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports